(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-offer-table', [
    'pp.widgets-templates',
    'pp.controllers.dashboard-table'
]);

ngModule.component('ppDashboardOfferTable', {
    templateUrl: 'widgets/_angular/dashboard-offer-table/dashboard-offer-table.tpl.html',
    bindings: {
        data: '<',
        openSidebarSymbol: '<',
        onChange: '&'
    },
    controllerAs: 'vm',
    controller: 'ppDashboardTableCtrl'
});
})(window, window.angular);